import type { ZodSchema } from '@vy/utils';
import type { FormDrawerProps } from '../../FormDrawer';
import { QuickBooksRegistration } from './QuickbooksRegistration';

export const RegisterToQuickBooksComponents: FormDrawerProps<ZodSchema<unknown>> = {
  ContentComponent: QuickBooksRegistration,
};
